import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useCompany from '../hooks/useCompany';
import CustomNavigate from '../components/CustomNavigate';

export default function NoCompanyMiddleware({ children }) {
    const { companies } = useCompany();
    const companyList = Array.isArray(companies) ? companies : [];

    if (companyList.length > 0) return <CustomNavigate to="/dashboard/home" />;
    return children;
}

NoCompanyMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};
